import React from 'react';
import ReactDOM from 'react-dom';

import './Style.css';

class ValidarEmpreendimento extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            empreendimentos: [
                {
                    id: 1,
                    name: 'Empreendimento 1',
                    evaluations: [
                        {
                            id: 1,
                            building_id: 1,
                            type: 'Avaliação',
                            reason: 'Estoque',
                            criterion: 'Critério 1',
                            building_type: [
                                'Vertical',
                                'Horizontal'
                            ],
                            building_status: [
                                'Ativo'
                            ],
                            weigth: 5,
                            rules: [
                                {
                                    id: 1,
                                    evaluation_id: 1,
                                    rule_name: 'Não atualizou o estoque',
                                    field_to_validate: 'name',
                                    no_rule: 0,
                                    conditionals: [
                                        {
                                            id: 1,
                                            evaluation_rule_id: 1,
                                            operator: 'igual_a',
                                            compare_with: 'outro_campo',
                                            fixed_value: null,
                                            field: 'name'
                                        },
                                        {
                                            id: 2,
                                            evaluation_rule_id: 1,
                                            operator: 'diferente_de',
                                            compare_with: 'valor_fixo',
                                            fixed_value: 'teste',
                                            field: null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: 2,
                            building_id: 1,
                            type: 'Avaliação',
                            reason: 'Preço',
                            criterion: 'Critério 1',
                            building_type: [
                                'Vertical',
                                'Horizontal'
                            ],
                            building_status: [
                                'Ativo'
                            ],
                            weigth: 5,
                            rules: [
                                {
                                    id: 2,
                                    evaluation_id: 2,
                                    rule_name: 'Preço incorreto',
                                    field_to_validate: 'name',
                                    no_rule: 0,
                                    conditionals: [
                                        {
                                            id: 3,
                                            evaluation_rule_id: 2,
                                            operator: 'igual_a',
                                            compare_with: 'outro_campo',
                                            fixed_value: null,
                                            field: 'name'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    name: 'Empreendimento 2',
                    evaluations: [
                        {
                            id: 3,
                            building_id: 2,
                            type: 'Avaliação',
                            reason: 'Preço',
                            criterion: 'Critério 1',
                            building_type: [
                                'Vertical',
                                'Horizontal'
                            ],
                            building_status: [
                                'Ativo'
                            ],
                            weigth: 5,
                            rules: [
                                {
                                    id: 3,
                                    evaluation_id: 3,
                                    rule_name: 'Não atualizou o preço',
                                    field_to_validate: 'name',
                                    no_rule: 1,
                                    conditionals: []
                                }
                            ]
                        }
                    ]
                }
            ]
        };
    }

    componentDidMount() {
        //
    }

    /**
     * Remove a inconsistência da linha.
     */
    handleRemoveInconsistencia = (
        empreendimentoId,
        evaluationId
    ) => {
        this.setState((previousState) => ({
            empreendimentos:
                previousState.empreendimentos.map(
                    (empreendimento) => {

                        if (
                            empreendimento.id !==
                            empreendimentoId
                        ) {
                            return empreendimento;
                        }

                        return {
                            ...empreendimento,

                            evaluations:
                                empreendimento.evaluations.filter(
                                    (evaluation) =>
                                        evaluation.id !==
                                        evaluationId
                                ),
                        };
                    }
                ),
        }));
    };

    /**
     * Remove o critério/regra da linha.
     */
    handleRemoveCriterio = (
        empreendimentoId,
        evaluationId,
        ruleId
    ) => {
        this.setState((previousState) => ({
            empreendimentos:
                previousState.empreendimentos.map(
                    (empreendimento) => {

                        if (empreendimento.id !== empreendimentoId) {
                            return empreendimento;
                        }

                        return {
                            ...empreendimento,

                            evaluations:
                                empreendimento.evaluations.map(
                                    (evaluation) => {

                                        if (evaluation.id !== evaluationId) {
                                            return evaluation;
                                        }

                                        return {
                                            ...evaluation,

                                            rules:
                                                evaluation.rules.filter(
                                                    (rule) =>
                                                        rule.id !==
                                                        ruleId
                                                ),
                                        };
                                    }
                                ),
                        };
                    }
                ),
        }));
    };

    /**
     * Executa a avaliação e remove a linha.
     */
    handleAvaliar = (empreendimento) => {
        console.log('Avaliar empreendimento:', { empreendimento });

        this.setState((previousState) => ({
            empreendimentos: previousState.empreendimentos.filter(
                (item) => item.id !== empreendimento.id
            ),
        }));
    };

    /**
     * Verifica se a avaliação ainda possui condições suficientes para exibir o botão Avaliar.
     */
    canAvaliar = (empreendimento) => {
        return (
            empreendimento.evaluations &&
            empreendimento.evaluations.length > 0
        );
    };

    render() {
        const {
            empreendimentos
        } = this.state;

        return (
            <div>
                <div className="lista-empreendimentos">
                    <div className="card" style={{ height: '100%' }}>
                        {empreendimentos.length === 0 ? (
                            <p className="title">Nenhuma avaliação encontrada.</p>
                        ) : (
                            <table className="table-stripped">
                                <thead>
                                    <tr>
                                        <th>Empreendimento</th>
                                        <th>Inconsistência</th>
                                        <th>Critério sugerido</th>
                                        <th>Erro</th>
                                        <th>Comentário</th>
                                        <th style={{ textAlign: 'center' }}>Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {empreendimentos.map(
                                        (empreendimento) => {
                                            const podeAvaliar = this.canAvaliar( empreendimento );

                                            return (
                                                <tr key={ empreendimento.id }>
                                                    {/* EMPREENDIMENTO */}
                                                    <td>
                                                        <a
                                                            href="http://"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            { empreendimento.name }
                                                        </a>
                                                    </td>

                                                    {/* INCONSISTÊNCIAS */}
                                                    <td>
                                                        <div className="botoes-inconsistencia">
                                                            {empreendimento.evaluations.map(
                                                                (
                                                                    evaluation
                                                                ) => (
                                                                    <button
                                                                        key={ evaluation.id }
                                                                        type="button"
                                                                        className="btn btn-inconsistencia"
                                                                    >
                                                                        { evaluation.reason }
                                                                        { ' ' }
                                                                        <span
                                                                            className="p-multiselect-token-icon pi pi-times-circle"
                                                                            onClick={() =>
                                                                                this.handleRemoveInconsistencia(
                                                                                    empreendimento.id,
                                                                                    evaluation.id
                                                                                )
                                                                            }
                                                                        ></span>
                                                                    </button>
                                                                )
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* CRITÉRIOS */}
                                                    <td>
                                                        <div className="botoes-inconsistencia">
                                                            {empreendimento.evaluations.map(
                                                                (
                                                                    evaluation
                                                                ) =>
                                                                    evaluation.rules.map(
                                                                        (
                                                                            rule
                                                                        ) => (
                                                                            <button
                                                                                key={ rule.id }
                                                                                type="button"
                                                                                className="btn btn-inconsistencia"
                                                                            >
                                                                                { rule.rule_name }
                                                                                { ' ' }
                                                                                <span
                                                                                    className="p-multiselect-token-icon pi pi-times-circle"
                                                                                    onClick={() =>
                                                                                        this.handleRemoveCriterio(
                                                                                            empreendimento.id,
                                                                                            evaluation.id,
                                                                                            rule.id
                                                                                        )
                                                                                    }
                                                                                ></span>
                                                                            </button>
                                                                        )
                                                                    )
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* ERRO */}
                                                    <td>
                                                        <div className="erros-empreendimento">
                                                            {empreendimento.evaluations.map(
                                                                (
                                                                    evaluation
                                                                ) => {

                                                                    if (
                                                                        !evaluation.reason
                                                                    ) {
                                                                        return null;
                                                                    }

                                                                    const erro =
                                                                        evaluation.reason ===
                                                                        'Estoque'
                                                                            ? 'Estoque igual'
                                                                            : evaluation.reason ===
                                                                                'Preço'
                                                                                ? 'Preço incorreto'
                                                                                : '';

                                                                    if (!erro) {
                                                                        return null;
                                                                    }

                                                                    return (
                                                                        <div
                                                                            key={ evaluation.id }
                                                                        >
                                                                            { erro }
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* COMENTÁRIO */}
                                                    <td>
                                                        <textarea
                                                            name={`comentario-${empreendimento.id}`}
                                                            placeholder="Digite"
                                                        ></textarea>
                                                    </td>

                                                    {/* AÇÃO */}
                                                    <td
                                                        style={{ textAlign: 'center' }}
                                                    >
                                                        {podeAvaliar && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-avaliar"
                                                                onClick={() =>
                                                                    this.handleAvaliar(
                                                                        empreendimento
                                                                    )
                                                                }
                                                            >
                                                                Avaliar
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('app-validar-empreendimentos')) {
    ReactDOM.render(<ValidarEmpreendimento />, document.getElementById('app-validar-empreendimentos'));
}
export default ValidarEmpreendimento;